<template>
  <div class="wangeditor-wrapper">
    <editor
       api-key="qt9n3rg1coi1jqhkrbp58o27f72m3cia64qf6g4zkoj1hsnx"
       v-model='content'
       :init="{
        height: 500,
        plugins: 'print preview importcss searchreplace autolink autosave save directionality  visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help  charmap quickbars',
        a11y_advanced_options: true,
        menubar: 'file edit view insert format tools table help',
        toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
        toolbar_sticky: true,
        font_formats:
           'Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; Verdana=verdana,geneva;Webdings=webdings;AkrutiKndPadmini=Akpdmi-n;Andale Mono=andale mono,times;Book Antiqua=book antiqua,palatino;Tahoma=tahoma,arial,helvetica,sans-serif;Impact=impact,chicago;Comic Sans MS=comic sans ms,sans-serif;宋体=宋体;黑体=黑体;微软雅黑=微软雅黑;隶书=隶书;幼圆=幼圆',
        file_picker_types: 'file image media',
        language: 'zh_CN',
        fontsize_formats: '2px 4px 6px 8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px 38px 40px 42px 44px 46px 48px',
        toolbar_mode: 'sliding',
        image_uploadtab: true,
        file_picker_callback: file_picker_callback
       }"
     >12121</editor>
  </div>
</template>

<script>
import 'wangeditor/release/wangEditor.min.css'
import Editor from '@tinymce/tinymce-vue'
import { oneOf } from '@/libs/tools'
export default {
  name: 'v-wangeditor',
  components: {
    'editor': Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value (newVal, oldVal) {
      // if (this.newVal === this.oldVal)  return
      this.content = this.value
    },
    content (newVal) {
      this.$emit('input', newVal)
    }
  },
  data () {
    return {
      content: ''
    }
  },
  methods: {
    file_picker_callback (cb, value, meta) {
      //  cb('https://tpc.googlesyndication.com/simgad/8980322364285006136?sqp=4sqPyQQ7QjkqNxABHQAAtEIgASgBMAk4A0DwkwlYAWBfcAKAAQGIAQGdAQAAgD-oAQGwAYCt4gS4AV_FAS2ynT4&rs=AOga4qmH7EnU6iYYeqyXfYJgIspMSTMJVA', { title: '34324324' });
      var input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', 'image/*')
      input.onchange = function () {
        debugger
        var file = input.files[0]
        console.log(file)
        // cb(blobInfo.blobUri(), { title: file.name });
        if (typeof XMLHttpRequest === 'undefined') {
          return
        }

        const xhr = new XMLHttpRequest()
        const action = '/gdjx/file/upload/add'

        const formData = new FormData()

        // file 文件
        formData.append('file', file)

        // xhr.onerror = function error(e) {
        //   option.onError(e);
        // };

        xhr.onload = function onload () {
          if (xhr.status < 200 || xhr.status >= 300) {

            // return option.onError(getError(action, option, xhr));
          }
          let body = getBody(xhr) // 成功获取
          // TODO
          cb(body.data.fileUrl, { title: file.name })
        }

        xhr.open('post', action, true)
        if ('withCredentials' in xhr) {
          xhr.withCredentials = true
        }

        xhr.send(formData)
      }
      input.click()
    }
  }
}

function getBody (xhr) {
  const text = xhr.responseText || xhr.response
  if (!text) {
    return text
  }

  try {
    return JSON.parse(text)
  } catch (e) {
    return text
  }
}
</script>

<style lang="less">
.wangeditor-wrapper {
  &-toolbar {
    background-color: rgba(243, 243, 243, 0.6);
    padding: 10px 5px!important;
  }
  &-text {
    border: 1px solid #ccc;
    height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/editor/wangeditor.vue